import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Tooltip, Flex, Text } from '@radix-ui/themes';
import type { AddressRiskConnection, EntityRiskConnection } from '../types';
import { AddressRisk, EntityRisk } from '@/types';

type Risk = AddressRisk | EntityRisk;
type RiskConnection = AddressRiskConnection | EntityRiskConnection;

interface IRiskIndicatorProps {
  risks?: RiskConnection | null;
  className?: string;
}

export function RiskIndicator({ risks, className }: IRiskIndicatorProps) {
  if (!risks || risks.totalCount === 0) return null;

  const nodes = risks.edges?.map(edge => edge.node) || [];
  const tooltipContent = (
    <Flex direction="column" gap="1" style={{ maxWidth: '300px' }}>
      {nodes.map((risk: Risk) => (
        <Flex key={risk.id} direction="column" gap="1">
          <Text size="2" weight="bold" style={{ textTransform: 'uppercase' }}>
            {risk.riskType.replace(/_/g, ' ')}
            {risk.severity && (
              <Text size="1" color="gray" style={{ marginLeft: '4px' }}>
                ({risk.severity})
              </Text>
            )}
          </Text>
          {risk.description && (
            <Text size="1" color="gray">
              {risk.description}
            </Text>
          )}
        </Flex>
      ))}
    </Flex>
  );

  return (
    <Tooltip content={tooltipContent}>
      <ExclamationTriangleIcon
        className={className || 'inline-block'}
        style={{ color: 'var(--orange-11)', cursor: 'help' }}
      />
    </Tooltip>
  );
}
